import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { trackPageView } from "@/lib/analytics";

function getSessionId(): string {
  let id = sessionStorage.getItem("pv-session-id");
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem("pv-session-id", id);
  }
  return id;
}

function getUtmParams(): { utm_source: string | null; utm_medium: string | null; utm_campaign: string | null } {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get("utm_source"),
    utm_medium: params.get("utm_medium"),
    utm_campaign: params.get("utm_campaign"),
  };
}

export default function PageViewTracker() {
  const location = useLocation();
  const lastPath = useRef<string>("");

  useEffect(() => {
    const path = location.pathname;
    if (path === lastPath.current) return;
    lastPath.current = path;

    // Fire GA page view
    trackPageView(path);

    // Internal tracking — fire and forget
    const utm = getUtmParams();
    supabase
      .from("page_views" as any)
      .insert({
        path,
        referrer: document.referrer || null,
        utm_source: utm.utm_source,
        utm_medium: utm.utm_medium,
        utm_campaign: utm.utm_campaign,
        session_id: getSessionId(),
      })
      .then(() => {});
  }, [location.pathname]);

  return null;
}
